
import { Component, Vue, Prop } from "vue-property-decorator";
import TeacherItemM from "./components/TeacherItemM.vue";
import { teacherList } from "@/apis/home";
import Pagination from "@/components/pagination.vue";
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import { formatUpyunUrl } from "@/utils";
import { getPersonJsonLd, injectJsonLd } from "@/utils/seo";
@Component({
  components: {
    TeacherItemM,
    Pagination,
    Breadcrumb
  }
})
export default class Teacher extends Vue {
  formatUpyunUrl = formatUpyunUrl;
  total = 0;
  page = 1;
  per_page = 8;
  list: any = [];
  index: any = 0;
  List = [{ title: "讲师详情", url: "" }];
  info = {} as any;
  id = "" as any;
  loading = false;
  picList = [] as any;
  created() {
    if (this.$route.query.index) {
      this.index = this.$route.query.index;
    }
    // 优先从路径参数获取 id，兼容旧的 query 参数形式
    const routeId = this.$route.params.id || this.$route.query.id;
    if (routeId) {
      this.id = routeId as string;
    }
    this.teachInfo();
    this.teacherList();
  }
  handlePageChange(val: any) {
    this.page = val.page;
    this.teacherList();
  }

  async teachInfo() {
    const data = await teacherList({
      action: "info",
      type: 2,
      id: this.id
    });

    console.log("teachInfo", data);

    this.info = data || {};
    this.picList = [];
    if (this.info.pic1) {
      this.picList.push(this.info.pic1);
    }
    if (this.info.pic2) {
      this.picList.push(this.info.pic2);
    }
    if (this.info.pic3) {
      this.picList.push(this.info.pic3);
    }
    if (this.info.pic4) {
      this.picList.push(this.info.pic4);
    }
    if (this.info.pic5) {
      this.picList.push(this.info.pic5);
    }
    // 注入 Person JSON-LD
    if (data && data.name) {
      injectJsonLd(
        "jsonld-person",
        getPersonJsonLd({
          name: data.name,
          title: data.lingyu || "培训讲师",
          description:
            typeof data.zhiyebg2 === "string"
              ? data.zhiyebg2.replace(/<[^>]+>/g, "").substring(0, 300)
              : data.shanchang || "",
          image: data.pic ? formatUpyunUrl(data.pic) : undefined
        })
      );
    }
  }
  async teacherList() {
    this.loading = true;
    const { data, total } = await teacherList({
      action: "list",
      type: 2,
      page: this.page,
      per_page: this.per_page
    });
    this.total = total;
    if (this.list.length < this.total) {
      this.list.push(...data);
    }
    // this.list = data;
    // this.total = total;
    // if (this.index > 0) {
    //   this.$nextTick(() => {
    //     window.location.hash = "#li" + this.index;
    //   });
    // }
    this.loading = false;
  }
  clickTeacher(item: any, index: any) {
    this.id = item.id;
    this.teachInfo();
  }

  onLazyLoad(event: any) {
    const { scrollTop, scrollHeight, clientHeight } = event.target;
    // 检查是否滚动到底部
    if (scrollTop + clientHeight >= scrollHeight - 10) {
      // 留出10px的缓冲
      if (!this.loading) {
        this.page++;
        this.teacherList();
      }
      // console.log(123456);
    }
  }

  mounted() {
    const metaTag1 = document.createElement("meta");
    metaTag1.setAttribute("name", "keywords");
    metaTag1.setAttribute(
      "content",
      "光华介绍，光华师资，光华动态，客户案例，效果看得见，"
    );
    document.head.appendChild(metaTag1);
    const metaTag2 = document.createElement("meta");
    metaTag2.setAttribute("name", "description");
    metaTag2.setAttribute(
      "content",
      "企业培训咨询数字化转型，找光华，企业培训咨询数字化转型 |，找光华，服务一万家企业绩效飞轮*应用实践，帮助一万家企业BLM科学经营T系统落地，到2035年，赋能陪跑企业合计GDP超一万亿规模，用科学经营助推企业高质量发展讲师说明：董权、霍振先、潘亦藩、蔡毅臣、杨波、方永飞 所有老师的名字动态说明：动态标题，客户案例说明：客户案例标题"
    );
    document.head.appendChild(metaTag2);
  }
}
